import { useState } from 'react';

const faqs = [
  {
    q: '漫画更新提醒是如何工作的？',
    a: '你只需订阅关注的漫画作品，当最新话更新时，漫迹就会通过站内与推送第一时间提醒你，无需每天手动刷新查询。',
  },
  {
    q: '最新话推送会打扰我吗？',
    a: '完全按需定制。你可以为每一部作品单独设置是否提醒，也可以调整提醒方式，真正做到零打扰、不错过。',
  },
  {
    q: '如何查看连载进度？',
    a: '进入任意漫画的详情即可查看连载状态、总话数、最新章节与更新频率，连载进度一目了然。',
  },
  {
    q: '追更社区有什么内容？',
    a: '社区汇聚了大量追更同好，可以交流剧情、分享心得、安利新作、参与话题讨论，让追更更有乐趣。',
  },
  {
    q: '更新日历有什么用？',
    a: '更新日历按星期展示每周各作品的更新安排，帮你提前规划追更时间，轻松掌握追更节奏。',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="mx-auto max-w-4xl px-4 py-14 md:px-6 md:py-20">
      <div className="mb-8 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-900">
          <i className="ri-question-line" /> 常见问题
        </span>
        <h2 className="mt-3 font-heading text-3xl text-foreground-950">你可能想知道</h2>
      </div>

      <div className="flex flex-col gap-3">
        {faqs.map((f, i) => (
          <div
            key={f.q}
            className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
          >
            <button
              type="button"
              onClick={() => setOpen(open === i ? null : i)}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
            >
              <span className="text-sm font-bold text-foreground-950">{f.q}</span>
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-900 transition-transform ${
                  open === i ? 'rotate-180' : ''
                }`}
              >
                <i className="ri-arrow-down-s-line" />
              </span>
            </button>
            <div
              className={`grid transition-all duration-300 ${
                open === i ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-5 pb-4 text-sm leading-relaxed text-foreground-600">{f.a}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}